import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { notBecause, painPoints, planningQuestions, scratchHabits } from '../data/painPoints';
const reveal = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }
} as const;
export function PainPoints() {
  return <section className="py-24 px-4 bg-slate-50" data-id="element-151" data-mp="1xx851xfk5z8e">
      <div className="max-w-4xl mx-auto" data-id="element-152" data-mp="1xwg9gmlyo1i4">
        <motion.div {...reveal} className="text-center mb-12" data-id="element-153" data-mp="21zuphd9wghvk">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6 text-blue-950 uppercase" data-id="element-154" data-mp="21x8jvj6kkcfz">
            Still Spending Hours Planning Every Dog Grooming Lesson?
          </h2>
          <div className="text-lg text-slate-800 leading-relaxed bg-white p-6 md:p-8 rounded-2xl border border-slate-200 text-left space-y-4" data-id="element-155" data-mp="1sywx5s8tpyst">
            <p data-id="element-156" data-mp="3ncfrkt7k519w">
              Another student.
              <br data-id="element-157" data-mp="3nc5yuxv4og0i" />
              Another lesson.
              <br data-id="element-158" data-mp="1z0exkpa70w3q" />
              Another evening deciding:
            </p>
            <ul className="space-y-2 pl-1" data-id="element-159" data-mp="1yyc23pq9uarm">
              {planningQuestions.map(question => <li key={question} className="flex items-start gap-3 text-blue-950 font-semibold" data-id="element-160" data-mp="1tzr9och9gvdq">
                  <span className="w-1.5 h-1.5 rounded-full bg-orange-500 shrink-0 mt-3" aria-hidden="true" data-id="element-161" data-mp="27utcuruq46mu" />
                  <span data-id="element-162" data-mp="1g1t0rmlplr5m">{question}</span>
                </li>)}
            </ul>
            <div data-id="element-163" data-mp="1b2psltafn4tf">
              {notBecause.map(line => <p key={line} className="text-blue-950 font-semibold" data-id="element-164" data-mp="1b4ap3ogb4xtx">
                  {line}
                </p>)}
            </div>
            <p data-id="element-165" data-mp="1k3nwmbkvfcc0">
              Because knowing professional grooming and having a{' '}
              <span className="text-blue-950 font-semibold" data-id="element-166" data-mp="30hnw5lft0zyq">complete teaching system</span> are two
              very different things.
            </p>
            <p className="text-blue-950 font-semibold" data-id="element-167" data-mp="2vhrs5m73x8j6">
              Without a system, every student can feel like another lesson you need to build from
              scratch.
            </p>
            <p data-id="element-168" data-mp="1y36pwij5cd2o">{scratchHabits.join(' ')}</p>
            <p data-id="element-169" data-mp="1y62tamdrjtyi">And the time you should spend teaching becomes planning time.</p>
          </div>
        </motion.div>

        <motion.div {...reveal} data-id="element-170" data-mp="274o6s34doisf">
          <h3 className="text-xl font-bold text-blue-950 mb-8 text-center uppercase tracking-wide" data-id="element-171" data-mp="273v8zrned3mf">
            The Real Cost of Planning Everything From Scratch
          </h3>
          <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm shadow-blue-950/5" data-id="element-172" data-mp="1efr252t3aki5">
            {painPoints.map((point, index) => <motion.p key={point} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-3 px-5 py-4 text-slate-800 text-sm leading-relaxed border-t first:border-t-0 border-slate-200" data-id="element-173" data-mp="1jdis3ra6bwjp" data-mpi={index}>
                <X size={16} className="text-red-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-174" data-mp="j86vege3j49k" />
                {point}
              </motion.p>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-slate-200" data-id="element-175" data-mp="a6qwb4sqeokn">
            <p className="text-2xl font-bold tracking-tight text-blue-950" data-id="element-176" data-mp="a8tkdjabq7mq">
              Your grooming knowledge is already there.
            </p>
            <p className="text-xl mt-4 text-slate-800" data-id="element-177" data-mp="fmii8esl9re">
              What you need is a <span className="text-orange-500 font-semibold" data-id="element-178" data-mp="3rmp7qub2l5yz">system</span> that
              helps you use it faster, more visually and more professionally.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}